// extracted by mini-css-extract-plugin
export default {"root":"Pagination-root-ac95"};